import { createUseStyles } from 'react-jss';
import { ITheme } from '@quicktools/shared-components/styles/theme';
import { mediaQuery } from '@quicktools/shared-components/styles/helpers';

const useStyle = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    '@global': {
      '.lfta-landing': {
        paddingTop: '40px ',
      },
    },
    root: {},
    tagLines: {
      [mediaQuery(breakpoints.tablet)]: {
        paddingInline: 24,
      },
    },
    margined: {
      marginBottom: 40,

      [mediaQuery(breakpoints.tablet)]: {
        marginBottom: 0,
      },
    },
    reviewSnippet: {
      background: 'var(--x-bg-1)',
      margin: 0,
      marginTop: 16,
    },
  }),
  { name: 'landing' },
);

export default useStyle;
